import { Badge } from '@/components/ui/badge'

/** Marca ámbar de una tarea con un comentario de otra persona que el usuario no leyó. */
export function SinLeerBadge() {
  return (
    <Badge
      variant="outline"
      className="text-xs whitespace-nowrap shrink-0 gap-1 bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-900 dark:text-amber-300 dark:border-amber-800"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-amber-500" aria-hidden="true" />
      Sin leer
    </Badge>
  )
}
